export enum AsyncStorageKeys {
  InitialHouseholdsByUserId = 'InitialHouseholdsByUserId',
  UPLog = 'UP_log',
}
